import React from "react";
import {NavBar, WhiteSpace, Accordion, List, Badge} from "antd-mobile";

const Item = List.Item;
const Brief = Item.Brief;
export default class EntityInfo extends React.Component {


    render() {
        const {hideInfo, selectedMention, MentionRelations} = this.props;

        const panel = MentionRelations.map((item, index) => {
            const source = item.source['mention'];
            const target = item.target['mention'];
            const header = <div>
                {source + '-' + target}
                <Badge text={item['sentences'].length} style={{marginLeft: 10}}/>
            </div>;
            const listItem = item['sentences'].map((d, i) => {
                let sentence = d.sentence + '...';
                sentence.replace(/\s+/g, '');
                sentence = sentence.replace(source, `<span style="color: #ff7f0e">${source}</span>`);
                sentence = sentence.replace(target, `<span style="color: #ff7f0e">${target}</span>`);
                return <Item wrap={true} key={'listItem' + i}>
                    <span dangerouslySetInnerHTML={{__html: sentence}}/>
                    <Brief><a target={'_blank'} href={d['url']}>{d['publisher']}<br/>{d['title']}</a></Brief>
                </Item>
            });
            return <Accordion.Panel header={header} key={'panel' + index}>
                <List>
                    {listItem}
                </List>
            </Accordion.Panel>
        });

        return <div>
            <NavBar
                mode="dark"
                leftContent={'back'}
                onLeftClick={hideInfo}
            >{selectedMention}</NavBar>
            <WhiteSpace size="lg"/>
            <Accordion accordion={true}>
                {panel}
            </Accordion>
        </div>
    }
}
